import script from "./History-item.vue?vue&type=script&setup=true&lang=js"
export * from "./History-item.vue?vue&type=script&setup=true&lang=js"

import "./History-item.vue?vue&type=style&index=0&id=6c586a83&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c586a83"]])

export default __exports__